export const authModalInitialState = {
    showModal: "",
};
